import { Injectable, ElementRef, Renderer } from '@angular/core';

import { ApiService, AppContext, CacheService, LogService, SeoService } from './../shared';
import { Vessel, Voyages } from './../shared/models';

@Injectable()
export class VesselsService {
  public loaderOff = false;
  public noResult = false;
  public noVesselData = false;
  el: HTMLElement;
  content: HTMLElement;
  container: HTMLElement;

  constructor(private api: ApiService, public app: AppContext, private cache: CacheService, private logger: LogService, private seo: SeoService, el: ElementRef, private renderer: Renderer) {
  }

  getVoyages(vesselId: number, params: any): Promise<any> {
    this.logger.log('vessels.service', 'getVoyages', vesselId);
    // let cache = this.cache.get('vessels' + this.queryString);
    let promise = this.api.getApiClient().then(client => this.callGetVoyages(client, vesselId, params));
    // let server = Observable.fromPromise(promise);
    // this.voyages = server;
    // this.voyages = Observable.concat(cache, server);
    // this.cache.updateCache('vessels' + this.queryString, this.voyages);

    return promise;
  }

  callGetVoyages(apigClient: any, vesselId: number, paramsToSend: any): Promise<any> {
    this.logger.log('vessels.service', 'callGetVoyages', vesselId);
    return new Promise((resolve, reject) => {
      let params = {
        vesselId: vesselId
      };
      let body = {};
      let additionalParams = {
        headers: { 'Content-Type': 'application/json' },
        queryParams: paramsToSend
      };
      try {
        apigClient.vesselsVesselIdSchedulesGet(params, '', additionalParams)
          .then((result) => {
            this.logger.log('vessels.service', 'voyages result', result);
            if (!this.formatUI(result)) {
              resolve(null);
            }

            let voyages = new Voyages(result, this.app.accountType);
            resolve(voyages);
          }).catch((err) => {
            this.resizeSidebar();
            this.loaderOff = true;
            this.noResult = true;
            reject(this.api.handleError(err));
          });
      } catch (ex) {
        reject(null);
      }
    });
  }

  formatUI(result): boolean {
    if (result.data === null) {
      this.resizeSidebar();
      this.loaderOff = true;
      this.noResult = true;
      return false;
    } else if (result.data.hasOwnProperty('errorMessage')) {
      let response = JSON.parse(result.data.errorMessage);
      this.resizeSidebar();
      this.loaderOff = true;
      this.noResult = true;
      this.api.handleError(response);
      return false;
    } else if (result.data.items === undefined || result.data.items.length === 0 || result.data.summary.count === 0) {
      this.resizeSidebar();
      this.loaderOff = true;
      this.noResult = true;
      return false;
    } else {
      this.resizeSidebar();
      this.loaderOff = true;
      return true;
    }
  }

  getVessel(vesselId: number): Promise<any> {
    this.logger.log('vessels.service', 'getVessel', vesselId);
    // let cache = this.cache.get('vessels' + vesselId);
    let promise = this.api.getApiClient().then(client => this.callGetVessel(client, vesselId));
    // let server = Observable.fromPromise(promise);
    // this.vessel = server;
    // this.vessel = Observable.concat(cache, server);
    // this.cache.updateCache('vessels' + vesselId, this.vessel);

    return promise;
  }

  callGetVessel(apigClient: any, vesselId): Promise<any> {
    this.logger.log('vessels.service', 'callGetVessel', vesselId);
    return new Promise((resolve, reject) => {
      let params = {};
      let additionalParams = {
        headers: { 'Content-Type': 'application/json' },
        queryParams: {
          id: vesselId
        }
      };
      try {
        apigClient.vesselsGet(params, '', additionalParams)
          .then((result) => {
            this.logger.log('vessels.service', 'vessel result', result);
            if (result.data === null) {
              this.noVesselData = true;
            } else if (result.data.items !== undefined) {
              if (result.data.items.length === 0 || result.data.summary.count === 0) {
                this.noVesselData = true;
              } else {
                this.noVesselData = false;
              }
            } else {
              this.noVesselData = true;
            }

            let vessel = new Vessel(result.data.items[0], this.app.accountType);
            this.seo.setVessel(vessel);

            resolve(vessel);
          }).catch((err) => {
            this.noVesselData = true;
            reject(this.api.handleError(err));
          });
      } catch (ex) {
        reject(null);
      }
    });
  }

  resizeSidebar() {
    setTimeout(() => {
      try {
        this.el = document.getElementById('refine-sidebar-inner');
        this.content = document.getElementById('results-content');
        this.container = document.getElementById('content-sidebar-wrapper');

        this.renderer.setElementProperty(this.container, 'style', false);

        if (this.el.scrollHeight > this.content.scrollHeight) {

          let heightNum = (this.el.scrollHeight + 200);
          this.renderer.setElementStyle(this.container, 'height', heightNum + 'px');
        }
      } catch (ex) {
      }
    }, 50);
  }
}



// WEBPACK FOOTER //
// ./node_modules/angular-router-loader/src!./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./src/app/vessels/vessels.service.ts